import React from 'react';
import Icon from 'components/AppIcon';
import Tooltip from 'components/Tooltip';

const CARDS = [
  {
    key: 'totalWeight',
    label: 'Peso Total',
    icon: 'Scale',
    unit: 't',
    color: '#6366f1',
    bg: 'rgba(99,102,241,0.1)',
    tooltip: {
      title: 'Peso Total del Inventario',
      description: 'Suma del peso en toneladas de todos los lotes activos (En Espera, Procesando, Listo para Venta).',
      example: '12.50 t = suma de todos los lotes activos',
    },
  },
  {
    key: 'totalExposure',
    label: 'Exposición Total',
    icon: 'TrendingUp',
    unit: '€',
    color: '#EA580C',
    bg: 'rgba(234,88,12,0.1)',
    isCurrency: true,
    tooltip: {
      title: 'Exposición Total (€)',
      description: 'Capital total comprometido en inventario activo. Calculado como Precio de Compra × Peso (t) para cada lote.',
      example: '50.000 € = 5 t × 10.000 €/t',
    },
  },
  {
    key: 'activeLots',
    label: 'Lotes Activos',
    icon: 'Layers',
    unit: '',
    color: '#059669',
    bg: 'rgba(5,150,105,0.1)',
    tooltip: {
      title: 'Lotes Activos',
      description: 'Número de lotes con estado En Espera, Procesando o Listo para Venta. No incluye lotes Vendidos.',
    },
  },
  {
    key: 'avgAge',
    label: 'Edad Media',
    icon: 'Clock',
    unit: 'días',
    color: '#D97706',
    bg: 'rgba(217,119,6,0.1)',
    tooltip: {
      title: 'Edad Media del Inventario',
      description: 'Promedio de días desde la creación de cada lote activo. Valores altos pueden indicar riesgo de obsolescencia o dificultad de venta.',
      example: 'Umbral de alerta configurable en Ajustes',
    },
  },
];

export default function InventoryOverviewCards({ stats, loading }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {CARDS?.map((card) => {
        const raw = stats?.[card?.key] ?? 0;
        const display = card?.isCurrency
          ? raw?.toLocaleString('es-ES', { maximumFractionDigits: 0 })
          : card?.key === 'totalWeight' ? raw?.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          : raw?.toLocaleString('es-ES', { maximumFractionDigits: 1 });
        return (
          <div
            key={card?.key}
            className="bg-card border border-border rounded-xl p-5 flex flex-col gap-3"
            style={{ boxShadow: 'var(--shadow-sm)' }}
          >
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider" style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>
                <Tooltip title={card?.tooltip?.title} description={card?.tooltip?.description} example={card?.tooltip?.example}>
                  {card?.label}
                </Tooltip>
              </span>
              <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: card?.bg }}>
                <Icon name={card?.icon} size={16} color={card?.color} strokeWidth={2} />
              </div>
            </div>
            {loading ? (
              <div className="h-8 w-24 bg-muted animate-pulse rounded" />
            ) : (
              <div className="flex items-baseline gap-1.5">
                {card?.isCurrency && <span className="text-sm text-muted-foreground">€</span>}
                <span className="text-2xl font-bold text-foreground" style={{ fontFamily: '"IBM Plex Mono", monospace' }}>
                  {display}
                </span>
                {card?.unit && !card?.isCurrency && (
                  <span className="text-sm text-muted-foreground">{card?.unit}</span>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
